import { Box, Typography } from "@mui/material";
import React from "react";
import hero from "../assets/browse-job/hero.png";
import SearchBar from "./SearchBar";
const FindJobSection = ({ searchHandler, locations, specialities }) => {
  return (
    <Box sx={{ bgcolor: "rgba(33, 64, 75, 1)", py: "2rem" }}>
      <Box
        sx={{
          maxWidth: "1620px !important",
          mx: "auto",
          //   px: "15px",
          display: "flex",
          alignItems: "center",
          flexDirection: { xs: "column-reverse", md: "row" },
          gap: { xl: "6rem" },
        }}
      >
        <Box sx={{ flex: 1, p: 2, maxWidth: { md: 653 } }}>
          <Typography
            variant="body2"
            sx={{
              fontWeight: { xs: 400, xl: 500 },
              fontSize: { xs: "1rem", xl: "20px" },
              lineHeight: "24px",
              letterSpacing: "0.4px",
              color: "white",
              p: 2,
            }}
          >
            A job Board for Doctors and Nurses{" "}
          </Typography>
          <Typography
            variant="h3"
            sx={{
              fontWeight: { xs: 500, xl: 400 },
              fontSize: { xs: "1.5rem !important", xl: "70px !important" },
              mt: { xs: "1rem", xl: "56px" },
              lineHeight: { xs: "34px", xl: "79px" },
              color: "#fff",
              fontFamily: "DM Serif Text",
            }}
          >
            <span style={{ color: "rgba(233,196,106,1)" }}>Find</span> your
            <span style={{ color: "rgba(233,196,106,1)" }}> Job</span> today
            within minutes.
          </Typography>
          {/* ------------------------ search inputs  */}
          <Box sx={{ mt: { xs: "2rem", xl: "64px" } }}>
            <SearchBar
              searchHandler={searchHandler}
              locations={locations}
              specialities={specialities}
            />
          </Box>
        </Box>
        <Box
          sx={{
            flex: 1,
            p: 2,
            width: { xs: "100%", xl: "820px" },
            height: { xs: "100%", xl: "611px" },
          }}
        >
          <Box
            component={"img"}
            // src={hero}
            src={
              "https://projects.tangiblethemes.com/Shglocums/wp-content/uploads/2024/12/hero.png"
            }
            sx={{ objectFit: "contain", width: { xs: "100%", xl: "820px" } }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default FindJobSection;
